/**
 * 文字列から,や%や*を取り除く
 */
export const removeSpecialString = (v: string) => {
  return v.replace(/,|%|\*/g, '');
};
